// extracted by mini-css-extract-plugin
module.exports = {"search-result":"search-result--3tx47I00pz","searchResult":"search-result--3tx47I00pz","title":"title--3z0aYJTW8R","url":"url--3eM1pVPtdN","description":"description--vwYuP4w_ka"};